import ModalTriggerComponent from './ModalTriggerComponent';

export default class ZoomModalTriggerComponent extends ModalTriggerComponent {
  get Messages() {
    return {
      ...super.Messages,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.afterOpen]: this.setImage,
      [this.CUSTOM_MESSAGES.MODAL_EVENTS.beforeClose]: this.resetImage

    };
  }

  get SELECTORS() {
    return {
      container: '.js-zoom-image-container',
      mobileImage: '.js-mobile-zoom-img'
    };
  }

  constructor(element) {
    super(element);
  }

  setImage({ vexInstance }) {
    const modal = vexInstance.contentEl;
    const modalContent = modal.querySelector('.zoom-container');
    if (modalContent) {
      var mobileImageModal = modalContent.querySelector(this.SELECTORS.mobileImage);
      var containerModal = modalContent.querySelector(this.SELECTORS.container);

      if (this.image) {
        mobileImageModal.src = this.image;
        containerModal.style.backgroundImage = `url(${this.image})`;
      }
    }
  }

  resetImage({ vexInstance }) {
    const modal = vexInstance.contentEl;
    const modalContent = modal.querySelector('.zoom-container');
    if (modalContent) {
      var mobileImageModal = modalContent.querySelector(this.SELECTORS.mobileImage);
      var containerModal = modalContent.querySelector(this.SELECTORS.container);

      mobileImageModal.src = '';
      if (this.image) {
        containerModal.style.backgroundImage = '';
      }
    }
    this.image = '';
  }

  open(e) {
    this.image = e.target.src;
    var isGif = e.target.src.includes('.gif');
    if (isGif) {
      this.image = '';
    }
    super.open();
  }
}
